import axios from '@axios'

export const state = {
  tokens: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allTokens: (state) => state.tokens,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  RESET_TOKENS: (state) => {
    state.tokens = []
  },
  GET_TOKENS: (state, token) => {
    state.tokens = []
    if (!token) return false
    let { tokens, page, perPage, totalRecords, totalPages } = token
    state.tokens = tokens
    state.totalPages = totalPages
    state.currentPage = page
    state.totalRecords = totalRecords
    state.perPage = perPage
  },
  CREATE_TOKEN: (state, token) => {
    state.tokens.unshift(token)
  },
  REMOVE_TOKEN: (state, data) => {
    let token = state.tokens.filter((t) => {
      return t.id !== data.id
    })
    state.tokens = token
  },
  PATCH_TOKEN_STATUS: (state, token) => {
    for (let i = 0; i < state.tokens.length; i++) {
      if (state.tokens[i].id === token.id) {
        state.tokens[i].status = token.status
      }
    }
  },
  UPDATE_TOKEN: (state, token) => {
    for (let i = 0; i < state.tokens.length; i++) {
      if (state.tokens[i].id === token.id) {
        for (let field in token) {
          state.tokens[i][field] = token[field]
        }
        break
      }
    }
  },
}

export const actions = {
  async getTokens({ commit }, payload = {}) {
    let type = typeof payload.type === 'undefined' ? 'sms' : payload.type
    delete payload.type
    await axios
      .get(`/${type}/tokens`, { params: payload })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_TOKENS', resp.data)
        }
      })
      .catch(() => {
        commit('GET_TOKENS', { tokens: [] })
      })
  },

  async createToken({ commit }, token) {
    await axios.post(`/${token.type}/tokens`, token).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_TOKEN', resp.data)
      }
    })
  },

  async deleteToken({ commit }, token) {
    await axios.delete(`/${token.type}/tokens/${token.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_TOKEN', token)
      }
    })
  },

  async toggleToken({ commit, dispatch }, token = {}) {
    await axios
      .patch(`/${token.type}/tokens/${token.id}`, token)
      .then((resp) => {
        if (resp.status === 200) {
          commit('PATCH_TOKEN_STATUS', resp.data)
        }
      })
  },

  async updateToken({ commit, dispatch }, token = {}) {
    await axios.put(`/${token.type}/tokens`, token).then((resp) => {
      if (resp.status === 200) commit('UPDATE_TOKEN', resp.data)
    })
  },
}
